/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Feature_HeaderInputs */

const en_settings_feature_header = /** @type {(inputs: Settings_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature`)
};

const de_settings_feature_header = /** @type {(inputs: Settings_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktion`)
};

const fr_settings_feature_header = /** @type {(inputs: Settings_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctionnalité`)
};

const es_settings_feature_header = /** @type {(inputs: Settings_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Característica`)
};

const it_settings_feature_header = /** @type {(inputs: Settings_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caratteristica`)
};

const nl_settings_feature_header = /** @type {(inputs: Settings_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Functie`)
};

const pl_settings_feature_header = /** @type {(inputs: Settings_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkcja`)
};

const fi_settings_feature_header = /** @type {(inputs: Settings_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ominaisuus`)
};

const da_settings_feature_header = /** @type {(inputs: Settings_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktion`)
};

const sv_settings_feature_header = /** @type {(inputs: Settings_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktion`)
};

/**
* | output |
* | --- |
* | "Feature" |
*
* @param {Settings_Feature_HeaderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_feature_header = /** @type {((inputs?: Settings_Feature_HeaderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Feature_HeaderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_feature_header(inputs)
	if (locale === "fr") return fr_settings_feature_header(inputs)
	if (locale === "es") return es_settings_feature_header(inputs)
	if (locale === "it") return it_settings_feature_header(inputs)
	if (locale === "nl") return nl_settings_feature_header(inputs)
	if (locale === "pl") return pl_settings_feature_header(inputs)
	if (locale === "fi") return fi_settings_feature_header(inputs)
	if (locale === "da") return da_settings_feature_header(inputs)
	if (locale === "sv") return sv_settings_feature_header(inputs)
	return en_settings_feature_header(inputs)
});